const m = window.require("@ember/version");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;